import {Templates} from  './Templates.js';

class crumb {
	constructor(parent, e) {
		[this.el, this.$] = Templates(`BreadCrumbs.crumb`);
		this.$.text.innerText = e[0];
		this.el.setAttribute(`href`, e[1]);
		parent.appendChild(this.el);
	}
}
export class BreadCrumbs extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Templates(`BreadCrumbs`);
		this.attachShadow({mode:'open'});
		this.shadowRoot.appendChild(this.el);
		console.log(`Breadcrumbs:: this.innerHTML = `, this.innerHTML);
	}
	connectedCallback() {
		if (document.readyState=='loading') {
			document.addEventListener(`DOMContentLoaded`, evt=>{ this.connectedCallback() ; });
			return;
		}
		let script = null;
		if (this.hasAttribute(`script-id`)) {
			script = document.getElementById(this.getAttribute(`script-id`));
		} else {
			script = this.querySelector(`script`);
		}
		if (!script) {
			console.error(`Failed to find breadcrumbs script for `, this);
			return;
		}
		const js = JSON.parse(script.innerText);
		js.forEach( c => new crumb(this.shadowRoot, c) );
	}
}
customElements.define(`lateral-breadcrumbs`, BreadCrumbs);